import React from "react";
import { connect } from "react-redux";
import FormElement from "components/FormElement";
import { mapBatteryPacksValues } from "helpers/BatterySupplierHelper";

const BatteryPacksReadonly = ({ request }) => {
  if (!request || !request.batterySuppliers) return null;

  const formattedList = mapBatteryPacksValues(request.batterySuppliers);

  const renderEmptyMsg = () => (
    <p className="dark-teal bold form-control-static">No batteries selected</p>
  );

  return (
    <FormElement
      label="Batteries"
      list={formattedList}
      id="batteries"
      type="listOfLinksBSC"
      emptyMsg={renderEmptyMsg()}
    />
  );
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(BatteryPacksReadonly);
